module.exports = __webpack_public_path__ + "img/M-ON-1.f004d4f0.gif";